import { Panel } from "primereact/panel";
import { memo } from "react";
import { Chart } from "primereact/chart";
import { Button } from "primereact/button";
import { useReport } from "../../context/report";
import TabelaParadas from "../Tabelas/TabelaParadas";

import ChartDataLabels from 'chartjs-plugin-datalabels';

export default memo(function EficienciaGeral() {
    const { handlePrint, data, printing } = useReport();

    const LegendPlugin = {
        beforeInit(chart, legend, options) {
            const fitValue = chart.legend.fit;
            chart.legend.fit = function () {
                fitValue.bind(chart.legend)();
                return this.height += 50;
            }
        }
    }

    const ChartOthers = () => {
        const options = {
            maintainAspectRatio: false,
            layout: {
                padding: 20
            },
            plugins: {
                legend: {
                    display: true,
                    padding: 20
                },
                datalabels: {
                    display: 'auto',
                    anchor: 'end',
                    align: 'end',
                    font: {
                        size: 24,
                    },
                    formatter: (value) => {
                        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
                    },
                    color: "#2c3e50"
                },
            }
        }

        let paradas = data.paradas;
        let datasets = [];
        let labels = [];
        let total = 0;

        paradas.forEach(element => {
            total += element.tempo;
        });

        paradas.forEach(element => {
            let porcentagem = element.tempo * 100 / total;
            labels.push(element.nome + ' - ' + element.tempo + ' - ' + porcentagem.toFixed(2) + '%');
            datasets.push(porcentagem.toFixed(2));
        });

        const chartData = {
            labels: labels,
            datasets: [{
                label: 'Total',
                data: datasets,
                backgroundColor: [
                    '#2ecc71',
                    '#3498db',
                    '#9b59b6',
                    '#34495e',
                    '#f1c40f',
                    '#e67e22',
                    '#e74c3c',
                    '#55efc4',
                    '#fd79a8',
                    '#636e72',
                    '#000000'
                ]
            }],
        }

        return (
            <Chart
                id="chartParadas"
                data={chartData}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                options={options}
                plugins={[ChartDataLabels, LegendPlugin]}
                type="pie"
            />
        )
    };

    return (
        <div>
            <TabelaParadas data={data} name="relatorio" />

            <Panel header="Gráfico de Paradas" className="p-mt-3" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint('chartParadas')} />
                <ChartOthers />
            </Panel>
        </div>
    )
});